import React from 'react';

import { useField } from 'formik';

import classNames from 'classnames';

import { Input } from '../../..';

import './index.scss';

const MutatePreviewPageInput = ({ name, ...props }) => {
  const [field, fieldMeta] = useField(name);

  return (
    <Input
      placeholder="Title"
      {...props}
      {...field}
      className={classNames(
        'mutate-preview-page-title',
        { 'mutate-preview-page-title-error': fieldMeta.error },
        // eslint-disable-next-line react/destructuring-assignment
        props.className,
      )}
      type="text"
    />
  );
};

export default MutatePreviewPageInput;
